import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useDraggable } from "@dnd-kit/core";
import TitleIcon from "@mui/icons-material/Title";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import TableChartIcon from "@mui/icons-material/TableChart";
import FunctionsIcon from "@mui/icons-material/Functions";
import NotesIcon from "@mui/icons-material/Notes";
import SpaceBarIcon from "@mui/icons-material/SpaceBar";
import { SECTION_TYPES } from "../templateSchema";

const ICONS = {
  title: TitleIcon,
  detail: ViewHeadlineIcon,
  table: TableChartIcon,
  totals: FunctionsIcon,
  text: NotesIcon,
  spacer: SpaceBarIcon,
};

function PaletteItem({ def }) {
  const Icon = ICONS[def.icon] || NotesIcon;
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: "palette-" + def.type,
    data: { kind: "PALETTE_SECTION", sectionType: def.type },
  });
  return (
    <Paper
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      variant="outlined"
      sx={{
        p: 1,
        display: "flex",
        flexDirection: "column",
        gap: 0.25,
        cursor: "grab",
        userSelect: "none",
        opacity: isDragging ? 0.4 : 1,
        "&:hover": { borderColor: "primary.main", bgcolor: "action.hover" },
      }}
    >
      <Icon fontSize="small" color="primary" />
      <Typography variant="caption" fontWeight={700} lineHeight={1.2}>
        {def.label}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
        {def.hint}
      </Typography>
    </Paper>
  );
}

export default function SectionPalette() {
  return (
    <Box>
      <Typography variant="overline" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
        Sections · drag onto sheet
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
        {SECTION_TYPES.map((def) => (
          <PaletteItem key={def.type} def={def} />
        ))}
      </Box>
    </Box>
  );
}
